import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.458}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 8538 14196"
    {...props}
  >
    <defs>
      {/* <style>{".fil2{fill:#f7f7f7}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541822752">
        <path
          d="m0 5830 8538-8C8195 4699 6556 853 6027 0L2454 10 0 5830z"
          style={{
            fill: "#0f111c",
          }}
          className="fill"

        />
        <path
          d="M4479 8090c97 115 222-76 401 919 139 773 115 1490-35 2250l-388 954 22-4123zm-715 3567c-322-1081-306-2634 301-3633l-10 4218-291-585zm1541-5336c-306-227-505-99-614-94l-925-1c-37 0-209 5-311 21l495 813c-379 1261-858 1526-771 3243 98 1924 859 2378 199 3161l1785-25c-449-497-312-743-90-1481 162-538 277-1215 292-1805 39-1589-363-1979-804-3112l744-720z"
          style={{
            fill: "#1c1b17",
            // stroke: "#000",
            strokeWidth: 521.911,
          }}
          className="fill"

        />
        <path
          d="m4457 12213 388-954c150-760 174-1477 35-2250-179-995-304-804-401-919l-22 4123zM4055 12242l10-4218c-607 999-623 2552-301 3633l291 585z"
          className="fill"
          />
        <path
          d="M4201 13748c-1958-9-1347-117-1568 268 442 223 2810 256 3268 0-248-457-107-262-1700-268z"
          style={{
            fill: "#151521",
          }}
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
